module.exports = __webpack_public_path__ + "static/img/lost-ethereal-lucre-games-indie-game-logo.af8b6e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-lucre-games-indie-game-logo.jpg
// module id = o3xb
// module chunks = 0